import React from "react";
import Layout from "../layouts/Layout";
import Hero from "../components/courses/Hero";
import OurCourses from "../components/home/OurCourses";

const Courses = () => {
  return (
    <Layout>
      <Hero />
      <div id="all-courses-section">
        <OurCourses padding="px-4 lg:px-0 pt-8 md:pt-11" title="Our Courses" showSearch />
      </div>
    </Layout>
  );
};

export default Courses;
